import React from 'react';

import { FaXTwitter } from 'react-icons/fa6';

import { StyledTwitterSignIn } from './styles';
import { bemClassName } from '../../../../utils/bem';

const b = bemClassName('twitter-sign-in');

const TwitterSignIn = ({ onSignIn, variant = 'full' }) => {
  const handleClick = () => {
    onSignIn?.();
  };

  if (variant === 'icon') {
    return (
      <StyledTwitterSignIn>
        <button className={b('circle')} onClick={handleClick} type="button" title="Continue with X">
          <FaXTwitter className={b('circle-icon')} />
        </button>
      </StyledTwitterSignIn>
    );
  }

  return (
    <StyledTwitterSignIn>
      <button className={b()} onClick={handleClick} type="button">
        <FaXTwitter className={b('icon')} />
        <span className={b('text')}>Continue with X</span>
      </button>
    </StyledTwitterSignIn>
  );
};

export default TwitterSignIn;
